/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 22 21.75',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M20.63 10.8v8.58a1.87 1.87 0 01-1.87 1.87H2.37A1.87 1.87 0 01.5 19.39V3a1.87 1.87 0 011.87-1.88h8.2" _fill="none" _stroke="#fff" stroke-linecap="round" stroke-miterlimit="10"/><path pid="1" _fill="#fff" d="M19.52 0l-9.25 9.34-1.67 4.33 4.14-1.88L22 2.45 19.52 0z"/></g></g>'
  }
})
